<template>
  <div>
    <v-pagination
      id="paginate.navigation"
      v-model="localCurrent_page"
      :length="last_page"
      :total-visible="8"
      prev-icon="mdi-chevron-left"
      next-icon="mdi-chevron-right"
    ></v-pagination>
  </div>
</template>

<script>
export default {
  props: {
    current_page: {
      type: Number,
      required: true,
    },
    last_page: {
      type: Number,
      required: true,
    },
    pageNumber: {
      type: Number,
      required: true,
    },
    search: {
      type: String,
      required: true,
    },
  },
  watch: {
    current_page(value) {
      if (value === this.localCurrent_page) return;
      this.syncingFromProp = true;
      this.localCurrent_page = value;
    },
    localCurrent_page(newVal) {
      if (this.syncingFromProp) {
        this.syncingFromProp = false;
        return;
      }
      this.$emit("changeActionResponse", newVal, this.search);
      this.$nextTick(this.addNavLabels);
    },
  },
  data() {
    return {
      localCurrent_page: this.current_page,
      syncingFromProp: false,
    };
  },
  mounted() {
    this.$nextTick(this.addNavLabels);
  },
  methods: {
    addNavLabels() {
      const btns = this.$el.querySelectorAll(".v-pagination__navigation");
      if (btns.length < 2) return;

      const labels = ["Página anterior", "Próxima página"];
      [btns[0], btns[btns.length - 1]].forEach((btn, i) => {
        btn.setAttribute("aria-label", labels[i]);
        btn.setAttribute("title", labels[i]);

        const icon = btn.querySelector(".v-icon, i");
        if (icon) {
          icon.setAttribute("aria-hidden", "true");
          icon.style.pointerEvents = "none";
        }

        if (!btn.querySelector(".sr-only")) {
          const span = document.createElement("span");
          span.className = "sr-only";
          span.textContent = labels[i];
          btn.appendChild(span);
        }
      });
    },
  },
};
</script>
